import React, { useEffect } from 'react';
import * as echarts from 'echarts/core';
import { GaugeChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import styles from './ResolutionRate.module.scss';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import { useFetch } from 'hooks/useFetch';
import { dashboardEndpoints } from 'hooks/endpoints';

echarts.use([GaugeChart, CanvasRenderer]);

const ResolutionRate = ({
  botId,
  startDate,
  endDate,
  snapshotMode,
  botType,
}) => {
  const accent = '#17C0EB';
  const track = '#EAF0F6';
  const tick = '#C9D3E0';
  const label = '#86909C';

  const { data: rate, refetch } = useFetch(
    ['resolutionRate', startDate, endDate, botId, botType],
    dashboardEndpoints.getResolutionRate(startDate, endDate),
    { enabled: false },
    botId ? { botId: botId, chatSource: botType } : {}
  );
  useEffect(() => {
    if (botType !== undefined) {
      refetch();
    }
  }, [startDate, endDate, botType, botId]);

  const option = {
    series: [
      {
        type: 'gauge',
        startAngle: 220,
        endAngle: -40,
        min: 0,
        max: 100,
        center: ['50%', '60%'],
        radius: '92%',
        axisLine: {
          roundCap: false,
          lineStyle: { width: 22, color: [[1, track]] },
        },
        progress: {
          show: true,
          width: 22,
          roundCap: false,
          itemStyle: { color: accent },
        },
        splitNumber: 10,
        axisTick: {
          distance: 6,
          splitNumber: 5,
          length: 6,
          lineStyle: { color: tick, width: 1 },
        },
        splitLine: {
          distance: 6,
          length: 12,
          lineStyle: { color: tick, width: 2 },
        },
        axisLabel: {
          distance: 20,
          color: label,
          fontSize: 12,
        },
        pointer: {
          show: true,
          length: '54%',
          width: 4,
          itemStyle: { color: accent },
        },
        anchor: {
          show: true,
          size: 14,
          itemStyle: { color: '#fff', borderColor: accent, borderWidth: 4 },
        },
        detail: { show: false },
        data: [{ value: Number(rate?.data) }],
      },
    ],
  };

  return (
    <div className={styles['resolution-rate-container']}>
      <div className={styles['title-container']}>
        <span
          className={`${styles['title']} ${
            snapshotMode && styles['snapshotMode-title']
          }`}
        >
          Resolution Rate
        </span>
        {!snapshotMode && (
          <Tooltip
            content='Indicates the percentage of user questions
successfully answered by the chatbot.'
            className={styles['tooltip']}
          >
            <SvgWithBranding type='info' color='#682ECB' />
          </Tooltip>
        )}
      </div>
      <ReactEChartsCore
        echarts={echarts}
        option={option}
        className={styles['chart']}
      />
      <div className={styles['percentage-container']}>
        <span className={styles['percentage']}>
          {rate?.data !== undefined ? Number(rate.data).toFixed(1) : ''}%
        </span>
      </div>
    </div>
  );
};

export default ResolutionRate;
